<script setup lang="ts">
import Statistics from './statistics.vue'
import SendTest from './sendTest.vue'
import Send from './send.vue'
import Undo from './undo.vue'
import Redo from './redo.vue'
import Pause from './pause.vue'
import DripStatus from './dripStatus.vue'
import RSSScheduleIcon from './rssScheduled.vue'
import Mobile from './mobile.vue'
import MobileHidden from './mobileHidden.vue'
import Desktop from './desktop.vue'
import DesktopHidden from './desktopHidden.vue'
import ABTest from './ABTest.vue'
import { UIIcon } from '@gohighlevel/ghl-canvas'
import Trophy from './Trophy.vue'
import Eye from './Eye.vue'
import Click from './Click.vue'
import SquareList from './squareList.vue'
import CircleList from './circleList.vue'
import DiscList from './discList.vue'
import LowerAlphaList from './lowerAlphaList.vue'
import LowerGreek from './lowerGreek.vue'
import LowerRoman from './lowerRoman.vue'
import UpperAlpha from './upperAlpha.vue'
import UpperRoman from './upperRoman.vue'
import DecimalList from './decimalList.vue'
import Dots from './sidebar/Dots.vue'
import Text from './sidebar/Text.vue'
import ButtonIcon from './sidebar/ButtonIcon.vue'
import Social from './sidebar/Social.vue'
import Image from './sidebar/Image.vue'
import Divider from './sidebar/Divider.vue'
import FooterIcon from './sidebar/FooterIcon.vue'
import CodeIcon from './sidebar/CodeIcon.vue'
import VideoIcon from './sidebar/VideoIcon.vue'
import ShoppingCart from './sidebar/ShoppingCart.vue'
import Rss from './sidebar/Rss.vue'
import Layers from './sidebar/Layers.vue'
import Layout from './Layout.vue'
import ContentBottom from './ContentBottom.vue'
import ContentTop from './ContentTop.vue'
import ContentLeft from './ContentLeft.vue'
import ContentRight from './ContentRight.vue'
import ContentDoubleBottom from './ContentDoubleBottom.vue'
import ContentDoubleTop from './ContentDoubleTop.vue'
import LogoIcon from './sidebar/LogoIcon.vue'
import BlankDesign from './BlankDesign.vue'
import BlankCode from './BlankCode.vue'
import Faq from './sidebar/Faq.vue'
import Product from './Product.vue'
import Slider from './Slider.vue'
import PreviewUrl from './PreviewUrl.vue'
const props = defineProps({
  iconName: {
    type: String,
    required: true,
  },
  className: {
    type: String,
    required: false,
    default: '',
  },
  fillColor: {
    type: String,
    required: false,
    default: '#000',
  },
  strokeColor: {
    type: String,
    required: false,
    default: '#000',
  },
})
</script>

<template>
  <UIIcon
    v-if="!iconName.includes('custom')"
    :icon="iconName"
    :class="className"
  />
  <Statistics
    v-if="iconName === 'custom-icon:statistics'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <SendTest
    v-if="iconName === 'custom-icon:send-test'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Undo
    v-if="iconName === 'custom-icon:undo'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Redo
    v-if="iconName === 'custom-icon:redo'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <DripStatus
    v-if="iconName === 'custom-icon:drip-status'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <DripStatus
    v-if="iconName === 'custom-icon:filled-drip-status'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
    :filled="true"
  />
  <Send
    v-if="iconName === 'custom-icon:send'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Pause
    v-if="iconName === 'custom-icon:pause'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <RSSScheduleIcon
    v-if="iconName === 'custom-icon:rss'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <RSSScheduleIcon
    v-if="iconName === 'custom-icon:filled:rss'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
    :filled="true"
  />
  <Mobile v-if="iconName === 'custom-icon:mobile'" :fillColor="fillColor" />
  <MobileHidden
    v-if="iconName === 'custom-icon:mobile-hidden'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
  />
  <Desktop v-if="iconName === 'custom-icon:desktop'" :fillColor="fillColor" />
  <DesktopHidden
    v-if="iconName === 'custom-icon:desktop-hidden'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
  />
  <ABTest
    v-if="iconName === 'custom-icon:ab-test'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
  />
  <Trophy
    v-if="iconName === 'custom-icon:trophy'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Eye
    v-if="iconName === 'custom-icon:eye'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Click
    v-if="iconName === 'custom-icon:click'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <SquareList
    v-if="iconName === 'custom-square-list:click'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Dots
    v-if="iconName === 'custom-builder-sidebar-icon:dots'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <CircleList
    v-if="iconName === 'custom-circle-list:click'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Layout
    v-if="iconName === 'custom-builder-sidebar-icon:layout'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Text
    v-if="iconName === 'custom-builder-sidebar-icon:text'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <DiscList
    v-if="iconName === 'custom-disc-list:click'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Image
    v-if="iconName === 'custom-builder-sidebar-icon:image'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <LowerAlphaList
    v-if="iconName === 'custom-lower-alpha-list:click'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <ButtonIcon
    v-if="iconName === 'custom-builder-sidebar-icon:button'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <LogoIcon
    v-if="iconName === 'custom-builder-sidebar-icon:logo'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <LowerGreek
    v-if="iconName === 'custom-lower-greek-list:click'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Divider
    v-if="iconName === 'custom-builder-sidebar-icon:divider'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <LowerRoman
    v-if="iconName === 'custom-lower-roman-list:click'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <UpperAlpha
    v-if="iconName === 'custom-upper-alpha-list:click'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <UpperRoman
    v-if="iconName === 'custom-upper-roman-list:click'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <DecimalList
    v-if="iconName === 'custom-decimal-list:click'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Social
    v-if="iconName === 'custom-builder-sidebar-icon:social'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <FooterIcon
    v-if="iconName === 'custom-builder-sidebar-icon:footer'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <CodeIcon
    v-if="iconName === 'custom-builder-sidebar-icon:code'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <VideoIcon
    v-if="iconName === 'custom-builder-sidebar-icon:video'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <ShoppingCart
    v-if="iconName === 'custom-builder-sidebar-icon:shopping'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Rss
    v-if="iconName === 'custom-builder-sidebar-icon:rss'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Layers
    v-if="iconName === 'custom-builder-sidebar-icon:layers'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <ContentBottom
    v-if="iconName === 'custom-builder-layout-icon:content-bottom'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <ContentTop
    v-if="iconName === 'custom-builder-layout-icon:content-top'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <ContentLeft
    v-if="iconName === 'custom-builder-layout-icon:content-left'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <ContentRight
    v-if="iconName === 'custom-builder-layout-icon:content-right'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <ContentDoubleBottom
    v-if="iconName === 'custom-builder-layout-icon:content-double-bottom'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <ContentDoubleTop
    v-if="iconName === 'custom-builder-layout-icon:content-double-top'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <BlankDesign
    v-if="iconName === 'custom-blank-icon:design'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <BlankCode
    v-if="iconName === 'custom-blank-icon:code'"
    :fill-color="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Faq
    v-if="iconName === 'custom-builder-sidebar-icon:faq'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <Product
    v-if="iconName === 'custom-builder-sidebar-icon:product'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />

  <Slider
    v-if="iconName === 'custom-builder-sidebar-icon:image-slider'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
  <PreviewUrl
    v-if="iconName === 'custom-builder-sidebar-icon:preview-url'"
    :fillColor="fillColor"
    :strokeColor="strokeColor"
    :class="className"
  />
</template>

<style scoped></style>
